import axiosInstance from './axios';
import { LeaveType } from '../../types';

class LeaveTypesService {
  private basePath = '/leave-types';

  /**
   * Get all leave types with optional status filter
   */
  async getAll(status?: 'ACTIVE' | 'INACTIVE'): Promise<LeaveType[]> {
    const response = await axiosInstance.get<LeaveType[]>(this.basePath, {
      params: { status },
    });
    return response.data;
  }

  /**
   * Get only active leave types (for dropdowns)
   */
  async getActive(): Promise<LeaveType[]> {
    const response = await axiosInstance.get<LeaveType[]>(
      `${this.basePath}/active`
    );
    return response.data;
  }

  /**
   * Get leave type by ID
   */
  async getById(id: number): Promise<LeaveType> {
    const response = await axiosInstance.get<LeaveType>(
      `${this.basePath}/${id}`
    );
    return response.data;
  }
}

export const leaveTypesService = new LeaveTypesService();
